import React, { useState, useEffect, useCallback } from 'react';
import {

  View,
  Text,
  ScrollView,
  TouchableOpacity,
  TextInput,
  Image,
  Alert,
  Modal,
  FlatList,
  SafeAreaView,
  RefreshControl,
  Dimensions,
  StyleSheet
} from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import { Ionicons, MaterialCommunityIcons } from '@expo/vector-icons';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useFocusEffect } from '@react-navigation/native';
import axios from 'axios';
import * as Print from 'expo-print';
import * as Sharing from 'expo-sharing';

// ===== API Configuration =====
const API_BASE_URL = 'https://api.jobeng.ai';

const getCompanyId = async () => {
  try {
    const userData = await AsyncStorage.getItem('currentUser');
    if (userData) {
      const user = JSON.parse(userData);
      return user.company_id || user.companyId || null;
    }
    const companyProfile = await AsyncStorage.getItem('companyProfile');
    if (companyProfile) {
      const company = JSON.parse(companyProfile);
      return company.id || company.company_id || null;
    }
    return null;
  } catch (e) {
    console.error('Error getting company_id:', e);
    return null;
  }
};

const apiRequest = async (endpoint, options = {}) => {
  try {
    const companyId = await getCompanyId();
    // Split endpoint and query string
    const [path, queryString] = endpoint.split('?');
    // Route: auth/* goes to /api/auth/*, everything else to /api/data/{table}
    let baseUrl;
    if (path.startsWith('auth/')) {
      baseUrl = `${API_BASE_URL}/api/${path}`;
    } else {
      // Convert hyphens to underscores for DB table mapping
      const dbPath = path.replace(/-/g, '_');
      baseUrl = `${API_BASE_URL}/api/data/${dbPath}`;
    }
    const params = new URLSearchParams(queryString || '');
    if (companyId) params.set('company_id', companyId);
    const separator = params.toString() ? '?' : '';
    const url = `${baseUrl}${separator}${params.toString()}`;

    const response = await fetch(url, {
      headers: { 'Content-Type': 'application/json' },
      ...options,
      ...(options.body ? { body: JSON.stringify(options.body) } : {}),
    });

    if (!response.ok) throw new Error(`API error: ${response.status}`);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(`API request failed for ${endpoint}:`, error);
    throw error;
  }
};
// ===== End API Configuration =====


const { width } = Dimensions.get('window');

const API_BASE_URL2 = 'https://api.jobeng.ai';
const api2 = axios.create({ baseURL: API_BASE_URL2, timeout: 15000, headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-API-Key': '16a0651c78da416445e9c2946fb72fd9a6e4ce4a71ba610db15251050c3462ef' } });
api2.interceptors.request.use(async c => { try { const t = await AsyncStorage.getItem('auth_token'); if (t) c.headers.Authorization = 'Bearer ' + t; const bid = await AsyncStorage.getItem('company_id'); if (bid) c.params = { ...c.params, company_id: parseInt(bid) }; } catch {} return c; }, e => Promise.reject(e));
const EP2 = { employees: API_BASE_URL2 + '/api/data/employees', companyProfile: API_BASE_URL2 + '/api/data/company_profiles', evaluations: API_BASE_URL2 + '/api/data/employee_evaluations' };

const MentorDashboardScreen = ({ navigation, route }) => {
  const jobId = route?.params?.jobId || null;
  const jobTitle = route?.params?.jobTitle || '';
  const [companyLogo, setCompanyLogo] = useState(route?.params?.companyLogo || null);
  const [companyName, setCompanyName] = useState(route?.params?.companyName || '');
  const [companyId2, setCompanyId2] = useState(null);
  const [activeTab, setActiveTab] = useState('overview');
  const [searchQuery, setSearchQuery] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState('');
  const [selectedItem, setSelectedItem] = useState(null);
  const [refreshing, setRefreshing] = useState(false);
  const [mentorData, setMentorData] = useState({
    profile: {
      id: 'mentor_001',
      name: 'Dr. Sarah Wilson',
      title: 'Senior Software Engineer',
      department: 'Engineering',
      company: 'TechCorp',
      avatar: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150',
      email: 'sarah.wilson@techcorp.com',
      phone: '+1-555-0199',
      experience: '8 years',
      specialties: ['Web Development', 'React', 'Node.js', 'System Design', 'Team Leadership'],
      languages: ['English', 'Spanish'],
      timeZone: 'PST (UTC-8)',
      availability: 'Weekdays 9AM-5PM',
      rating: 4.9,
      totalMentored: 24,
      currentMentees: 3,
      maxCapacity: 5,
      joinDate: '2022-01-15',
      bio: 'Passionate about helping the next generation of developers. I specialize in full-stack development and love sharing knowledge about modern web technologies.',
      linkedIn: 'https://linkedin.com/in/sarahwilson',
      github: 'https://github.com/sarahwilson'
    },
    mentees: [
      {
        id: 'mentee_001',
        name: 'Alex Johnson',
        avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150',
        email: 'alex.johnson@university.edu',
        university: 'Tech University',
        major: 'Computer Science',
        year: 'Junior',
        program: 'Software Engineering Internship',
        startDate: '2024-10-01',
        endDate: '2024-12-15',
        status: 'Active',
        progress: 75,
        skills: ['JavaScript', 'React', 'Python'],
        goals: [
          'Master React development',
          'Learn system design principles',
          'Build a full-stack application'
        ],
        achievements: [
          'Completed first project milestone',
          'Presented to stakeholders',
          'Implemented user authentication'
        ],
        lastMeeting: '2024-10-20',
        nextMeeting: '2024-10-27',
        performance: {
          technical: 4.2,
          communication: 4.5,
          initiative: 4.0,
          teamwork: 4.3,
          overall: 4.25
        },
        feedback: 'Excellent progress on React development. Shows great initiative in learning new concepts.',
        notes: 'Focus on system design concepts in next sessions. Prepare for technical presentation.'
      },
      {
        id: 'mentee_002',
        name: 'Maria Garcia',
        avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150',
        email: 'maria.garcia@university.edu',
        university: 'State University',
        major: 'Information Systems',
        year: 'Senior',
        program: 'Full-Stack Development Internship',
        startDate: '2024-09-15',
        endDate: '2024-12-01',
        status: 'Active',
        progress: 85,
        skills: ['JavaScript', 'Node.js', 'MongoDB', 'Express'],
        goals: [
          'Deploy production application',
          'Learn DevOps practices',
          'Improve code review skills'
        ],
        achievements: [
          'Built REST API from scratch',
          'Implemented database optimization',
          'Led code review sessions'
        ],
        lastMeeting: '2024-10-18',
        nextMeeting: '2024-10-25',
        performance: {
          technical: 4.5,
          communication: 4.2,
          initiative: 4.8,
          teamwork: 4.4,
          overall: 4.47
        },
        feedback: 'Outstanding technical skills and leadership potential. Ready for advanced challenges.',
        notes: 'Discuss career path options. Introduce to senior team members for networking.'
      },
      {
        id: 'mentee_003',
        name: 'David Chen',
        avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150',
        email: 'david.chen@university.edu',
        university: 'Engineering College',
        major: 'Software Engineering',
        year: 'Sophomore',
        program: 'Summer Internship Program',
        startDate: '2024-10-15',
        endDate: '2024-12-30',
        status: 'Active',
        progress: 45,
        skills: ['Python', 'Java', 'Git'],
        goals: [
          'Learn web development fundamentals',
          'Build first web application',
          'Understand software development lifecycle'
        ],
        achievements: [
          'Completed Python basics',
          'Set up development environment',
          'Created first Git repository'
        ],
        lastMeeting: '2024-10-22',
        nextMeeting: '2024-10-29',
        performance: {
          technical: 3.8,
          communication: 4.0,
          initiative: 3.5,
          teamwork: 4.1,
          overall: 3.85
        },
        feedback: 'Good foundation in programming. Needs more confidence in problem-solving.',
        notes: 'Provide more hands-on coding exercises. Encourage participation in team discussions.'
      }
    ],
    meetings: [
      {
        id: 'meeting_001',
        menteeId: 'mentee_001',
        menteeName: 'Alex Johnson',
        title: 'Weekly Check-in: React Progress Review',
        date: '2024-10-27',
        time: '2:00 PM',
        duration: 60,
        type: 'Virtual',
        platform: 'Zoom',
        status: 'Scheduled',
        agenda: [
          'Review React component architecture',
          'Discuss state management patterns',
          'Plan next week\'s learning objectives',
          'Address any blockers'
        ],
        notes: '',
        actionItems: []
      },
      {
        id: 'meeting_002',
        menteeId: 'mentee_002',
        menteeName: 'Maria Garcia',
        title: 'Career Development Discussion',
        date: '2024-10-25',
        time: '3:30 PM',
        duration: 45,
        type: 'Virtual',
        platform: 'Google Meet',
        status: 'Scheduled',
        agenda: [
          'Discuss career goals and aspirations',
          'Review portfolio projects',
          'Networking opportunities',
          'Full-time job search strategy'
        ],
        notes: '',
        actionItems: []
      },
      {
        id: 'meeting_003',
        menteeId: 'mentee_001',
        menteeName: 'Alex Johnson',
        title: 'Project Milestone Review',
        date: '2024-10-20',
        time: '2:00 PM',
        duration: 60,
        type: 'Virtual',
        platform: 'Zoom',
        status: 'Completed',
        agenda: [
          'Demo project progress',
          'Code review session',
          'Technical challenges discussion',
          'Next milestone planning'
        ],
        notes: 'Great progress on the user authentication feature. Code quality is improving significantly. Discussed best practices for error handling.',
        actionItems: [
          'Implement input validation',
          'Add unit tests for auth module',
          'Research JWT best practices'
        ]
      }
    ],
    resources: [
      {
        id: 'resource_001',
        title: 'React Best Practices Guide',
        type: 'Document',
        category: 'Web Development',
        description: 'Comprehensive guide covering React patterns, hooks, and performance optimization.',
        url: 'https://react-guide.com',
        tags: ['React', 'JavaScript', 'Frontend'],
        sharedWith: ['mentee_001', 'mentee_003'],
        dateAdded: '2024-10-15'
      },
      {
        id: 'resource_002',
        title: 'System Design Interview Prep',
        type: 'Video Course',
        category: 'System Design',
        description: 'Video series covering system design fundamentals and interview preparation.',
        url: 'https://systemdesign.com',
        tags: ['System Design', 'Interviews', 'Architecture'],
        sharedWith: ['mentee_001', 'mentee_002'],
        dateAdded: '2024-10-10'
      },
      {
        id: 'resource_003',
        title: 'Git Workflow Tutorial',
        type: 'Tutorial',
        category: 'Version Control',
        description: 'Step-by-step tutorial on Git workflows and collaboration best practices.',
        url: 'https://git-tutorial.com',
        tags: ['Git', 'Version Control', 'Collaboration'],
        sharedWith: ['mentee_003'],
        dateAdded: '2024-10-18'
      }
    ],
    analytics: {
      totalMeetings: 24,
      averageMeetingRating: 4.7,
      totalHoursMentored: 96,
      menteeSuccessRate: 92,
      responseTime: '< 2 hours',
      monthlyStats: [
        { month: 'Jul', meetings: 8, hours: 32 },
        { month: 'Aug', meetings: 10, hours: 40 },
        { month: 'Sep', meetings: 12, hours: 48 },
        { month: 'Oct', meetings: 6, hours: 24 }
      ]
    },
    notifications: [
      {
        id: 'notif_001',
        type: 'meeting',
        title: 'Upcoming Meeting',
        message: 'Meeting with Alex Johnson in 30 minutes',
        date: '2024-10-27',
        read: false
      },
      {
        id: 'notif_002',
        type: 'feedback',
        title: 'Feedback Request',
        message: 'Maria Garcia has requested feedback on her project',
        date: '2024-10-26',
        read: false
      }
    ]
  });

  const [newMeeting, setNewMeeting] = useState({
    menteeId: '',
    title: '',
    date: '',
    time: '',
    duration: 60,
    type: 'Virtual',
    platform: 'Zoom',
    agenda: []
  });

  const [newResource, setNewResource] = useState({
    title: '',
    type: 'Document',
    category: '',
    description: '',
    url: '',
    tags: [],
    sharedWith: []
  });

  useEffect(() => {
    loadMentorData();
  }, []);

  // ── Company Logo ──
  useFocusEffect(useCallback(() => { loadCompanyLogo2(); }, []));
  const loadCompanyLogo2 = async () => {
    try { const cc = await AsyncStorage.getItem('company_profile'); if (cc) { const p = JSON.parse(cc); setCompanyLogo(p.logo || null); if (p.name || p.company_name) setCompanyName(p.name || p.company_name); }
      const cid = await AsyncStorage.getItem('company_id'); if (cid) { setCompanyId2(cid); try { const r = await api2.get(EP2.companyProfile, { params: { company_id: cid } }); if (r.data?.success && r.data.data?.length > 0) { const lp = r.data.data[0]; setCompanyLogo(lp.logo || null); if (lp.name || lp.company_name) setCompanyName(lp.name || lp.company_name); } } catch {} }
    } catch {} };

  const handleEvaluateMentee = (mentee) => { navigation?.navigate('EvaluationAssessmentScreen', { companyLogo, companyName, employeeId: mentee.id, employeeName: mentee.name, employeePosition: mentee.role || 'Mentee', employeeEmail: mentee.email }); };
  const handleViewInternships = () => { navigation?.navigate('InternshipManagementScreen', { companyLogo, companyName }); };
  const handleViewEmployees = () => { navigation?.navigate('EmployeeManagementScreen', { companyLogo, companyName }); };
  const handleMakeOffer = (mentee) => { navigation?.navigate('JobOfferManagementScreen', { companyLogo, companyName, applicantName: mentee.name, applicantEmail: mentee.email, position: mentee.role || '' }); };

  const loadMentorData = async () => {
    try {
      const cid = companyId2 || await AsyncStorage.getItem('company_id') || '1';
      const [mentorsR, menteesR, meetingsR, evalsR] = await Promise.allSettled([
        api2.get(EP2.employees, { params: { company_id: parseInt(cid), role: 'mentor', limit: 50 } }).catch(() => null),
        api2.get(EP2.employees, { params: { company_id: parseInt(cid), limit: 200 } }).catch(() => null),
        api2.get(API_BASE_URL2 + '/api/data/team_meetings', { params: { company_id: parseInt(cid), limit: 100 } }).catch(() => null),
        api2.get(EP2.evaluations, { params: { company_id: parseInt(cid), limit: 100 } }).catch(() => null),
      ]);
      const safeD = r => (r?.status === 'fulfilled' && r.value?.data?.success && Array.isArray(r.value.data.data)) ? r.value.data.data : [];
      const mentors = safeD(mentorsR); const mentees = safeD(menteesR); const meetings = safeD(meetingsR); const evals = safeD(evalsR);

      const transformedData = {
        profile: mentors[0] || mentorData.profile || { id: 'mentor_001', name: companyName || 'Mentor', title: 'Senior Mentor', department: 'Mentorship', company: companyName, avatar: companyLogo || 'https://via.placeholder.com/150', email: '', experience: '5+ years', specialties: ['Mentoring', 'Career Development'], languages: ['English'], rating: 4.5, totalMentored: mentees.length, currentMentees: mentees.filter(m => (m.status || '').toLowerCase() === 'active').length, maxCapacity: 10, joinDate: new Date().toISOString().split('T')[0], bio: 'Experienced mentor.' },
        mentees: mentees.length > 0 ? mentees.map(m => ({ id: m.id, name: m.name || m.full_name || 'Mentee', avatar: m.avatar || 'https://ui-avatars.com/api/?name=' + encodeURIComponent(m.name || 'M') + '&background=random', email: m.email || '', university: m.university || '', major: m.major || '', year: m.year || '', program: m.program || 'Mentorship', startDate: (m.start_date || m.created_at || '').split('T')[0], endDate: m.end_date || '', status: m.status || 'Active', progress: m.progress || Math.floor(Math.random() * 40 + 60), skills: m.skills || [], goals: m.goals || [], achievements: m.achievements || [], lastMeeting: (m.last_meeting || '').split('T')[0], nextMeeting: (m.next_meeting || '').split('T')[0], role: m.position || m.role || 'Mentee', performance: { technical: m.technical_rating || 4, communication: m.communication_rating || 4, initiative: m.initiative_rating || 4, teamwork: m.teamwork_rating || 4, overall: m.overall_rating || 4 }, feedback: m.feedback || '', notes: m.notes || '' })) : (mentorData.mentees || []),
        meetings: meetings.length > 0 ? meetings.map(mt => ({ id: mt.id, menteeId: mt.mentee_id, menteeName: mt.mentee_name || 'Mentee', title: mt.title || 'Meeting', date: (mt.date || mt.meeting_date || '').split('T')[0], time: mt.time || '14:00', duration: mt.duration || 60, type: mt.type || 'Virtual', platform: mt.platform || 'Zoom', status: mt.status || 'Scheduled', agenda: mt.agenda || [], notes: mt.notes || '', actionItems: mt.action_items || [] })) : (mentorData.meetings || []),
        resources: mentorData.resources || [],
        evaluations: evals.map(ev => ({ id: ev.id, menteeId: ev.employee_id, menteeName: ev.employee_name, rating: ev.overall_rating, feedback: ev.feedback, date: ev.evaluation_date })),
      };
      setMentorData(prev => ({ ...prev, ...transformedData }));
      await AsyncStorage.setItem('mentorData', JSON.stringify({ ...mentorData, ...transformedData }));
    } catch (error) {
      console.warn('API load failed, using cache:', error.message);
      try { const cached = await AsyncStorage.getItem('mentorData'); if (cached) setMentorData(prev => ({ ...prev, ...JSON.parse(cached) })); } catch {}
    }
  };

  const saveMentorData = async (data) => {
    try {
      try { await api2.put(EP2.employees + '/' + (data.profile?.id || ''), data.profile || {}); } catch {}
      await AsyncStorage.setItem('mentorData', JSON.stringify(data));
    } catch (error) { console.error('Error saving mentor data:', error); }
  };

  const scheduleMeeting = async (meetingData) => {
    try {
      const cid = companyId2 || await AsyncStorage.getItem('company_id') || '1';
      const r = await api2.post(API_BASE_URL2 + '/api/data/team_meetings', { ...meetingData, company_id: parseInt(cid), created_at: new Date().toISOString(), status: 'Scheduled' });
      if (r.data?.success) { await loadMentorData(); Alert.alert('Success', 'Meeting scheduled!'); return true; }
    } catch (e) { Alert.alert('Error', 'Failed to schedule meeting'); return false; }
  };

  const addResource = async (resourceData) => {
    try {
      const cid = companyId2 || await AsyncStorage.getItem('company_id') || '1';
      const r = await api2.post(API_BASE_URL2 + '/api/data/learning_resources', { ...resourceData, company_id: parseInt(cid), created_at: new Date().toISOString() });
      if (r.data?.success) { await loadMentorData(); Alert.alert('Success', 'Resource added!'); return true; }
    } catch (e) { Alert.alert('Error', 'Failed to add resource'); return false; }
  };

  const submitFeedback = async (menteeId, feedbackData) => {
    try {
      const cid = companyId2 || await AsyncStorage.getItem('company_id') || '1';
      const r = await api2.post(EP2.evaluations, { employee_id: menteeId, company_id: parseInt(cid), evaluator_id: (mentorData.profile || {}).id, evaluation_date: new Date().toISOString().split('T')[0], ...feedbackData, created_at: new Date().toISOString() });
      if (r.data?.success) { Alert.alert('Success', 'Feedback submitted!'); return true; }
    } catch (e) { Alert.alert('Error', 'Failed to submit feedback'); return false; }
  };

  const onRefresh = React.useCallback(() => {
    setRefreshing(true);
    loadMentorData();
    setTimeout(() => setRefreshing(false), 1000);
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric' 
    });
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'Active': return '#10B981';
      case 'Completed': return '#3B82F6';
      case 'Scheduled': return '#F59E0B';
      case 'Cancelled': return '#EF4444';
      default: return '#8E8E93';
    }
  };

  const renderHeader = () => (
    <LinearGradient
      colors={['#667eea', '#764ba2']}
      style={styles.header}
    >
      <SafeAreaView>
        <View style={styles.headerContent}>
          <TouchableOpacity
            style={styles.backButton}
            onPress={() => navigation.goBack()}
          >
            <Ionicons name="arrow-back" size={24} color="#FFFFFF" />
          </TouchableOpacity>
          
          <View style={styles.headerTitleContainer}>
            {companyLogo ? <Image source={{ uri: companyLogo || undefined }} style={{ width: 24, height: 24, borderRadius: 12, marginRight: 8 }} /> : null}<Text style={styles.headerTitle}>Mentor Dashboard</Text>
            <Text style={styles.headerSubtitle}>Guiding Future Leaders</Text>
          </View>
          
          <TouchableOpacity
            style={styles.notificationButton}
            onPress={() => {
              setModalType('notifications');
              setShowModal(true);
            }}
          >
            <Ionicons name="notifications" size={24} color="#FFFFFF" />
            {(mentorData.notifications || []).filter(n => !n.read).length > 0 && (
              <View style={styles.notificationBadge}>
                <Text style={styles.notificationBadgeText}>
                  {(mentorData.notifications || []).filter(n => !n.read).length}
                </Text>
              </View>
            )}
          </TouchableOpacity>
        </View>
      </SafeAreaView>
    </LinearGradient>
  );

  const renderTabBar = () => (
    <View style={styles.tabBar}>
      {[
        { key: 'overview', title: 'Overview', icon: 'home' },
        { key: 'mentees', title: 'Mentees', icon: 'people' },
        { key: 'meetings', title: 'Meetings', icon: 'calendar' },
        { key: 'resources', title: 'Resources', icon: 'library' }
      ].map((tab) => (
        <TouchableOpacity
          key={tab.key}
          style={[styles.tabItem, activeTab === tab.key && styles.activeTab]}
          onPress={() => setActiveTab(tab.key)}
        >
          <Ionicons 
            name={tab.icon} 
            size={20} 
            color={activeTab === tab.key ? '#667eea' : '#8E8E93'} 
          />
          <Text style={[
            styles.tabText, 
            activeTab === tab.key && styles.activeTabText
          ]}>
            {tab.title}
          </Text>
        </TouchableOpacity>
      ))}
    </View>
  );

  const renderOverview = () => (
    <ScrollView style={styles.content} showsVerticalScrollIndicator={false}>
      {/* Profile Summary */}
      <View style={styles.profileCard}>
        <View style={styles.profileHeader}>
          <Image source={{ uri: ((mentorData.profile || {}).avatar && (mentorData.profile || {}).avatar.startsWith('http')) ? (mentorData.profile || {}).avatar : undefined }} style={styles.profileAvatar} />
          <View style={styles.profileInfo}>
            <Text style={styles.profileName}>{(mentorData.profile || {}).name}</Text>
            <Text style={styles.profileTitle}>{(mentorData.profile || {}).title}</Text>
            <Text style={styles.profileDepartment}>{(mentorData.profile || {}).department} • {(mentorData.profile || {}).company}</Text>
            <View style={styles.ratingContainer}>
              <MaterialCommunityIcons name="star" size={16} color="#F59E0B" />
              <Text style={styles.ratingText}>{(mentorData.profile || {}).rating || 0}</Text>
              <Text style={styles.ratingCount}>({(mentorData.profile || {}).totalMentored || 0} mentees)</Text>
            </View>
          </View>
          <TouchableOpacity
            style={styles.editButton}
            onPress={() => {
              setModalType('editProfile');
              setShowModal(true);
            }}
          >
            <Ionicons name="pencil" size={20} color="#667eea" />
          </TouchableOpacity>
        </View>
      </View>

      {/* Quick Stats */}
      <View style={styles.statsGrid}>
        <View style={styles.statCard}>
          <MaterialCommunityIcons name="account-group" size={24} color="#667eea" />
          <Text style={styles.statNumber}>{(mentorData.profile || {}).currentMentees || 0}</Text>
          <Text style={styles.statLabel}>Current Mentees</Text>
        </View>
        <View style={styles.statCard}>
          <MaterialCommunityIcons name="calendar-clock" size={24} color="#10B981" />
          <Text style={styles.statNumber}>{(mentorData.analytics || {}).totalMeetings || 0}</Text>
          <Text style={styles.statLabel}>Total Meetings</Text>
        </View>
        <View style={styles.statCard}>
          <MaterialCommunityIcons name="clock-outline" size={24} color="#F59E0B" />
          <Text style={styles.statNumber}>{(mentorData.analytics || {}).totalHoursMentored || 0}</Text>
          <Text style={styles.statLabel}>Hours Mentored</Text>
        </View>
        <View style={styles.statCard}>
          <MaterialCommunityIcons name="chart-line" size={24} color="#EF4444" />
          <Text style={styles.statNumber}>{(mentorData.analytics || {}).menteeSuccessRate || 0}%</Text>
          <Text style={styles.statLabel}>Success Rate</Text>
        </View>
      </View>

      {/* Current Mentees Overview */}
      <View style={styles.sectionCard}>
        <View style={styles.sectionHeader}>
          <Text style={styles.sectionTitle}>Current Mentees</Text>
          <TouchableOpacity
            style={styles.sectionAction}
            onPress={() => setActiveTab('mentees')}
          >
            <Text style={styles.sectionActionText}>View All</Text>
            <Ionicons name="chevron-forward" size={16} color="#667eea" />
          </TouchableOpacity>
        </View>
        {(mentorData.mentees || []).slice(0, 3).map((mentee) => (
          <View key={mentee.id} style={styles.menteePreviewCard}>
            <Image source={{ uri: (mentee.avatar && mentee.avatar.startsWith('http')) ? mentee.avatar : undefined }} style={styles.menteeAvatar} />
            <View style={styles.menteeInfo}>
              <Text style={styles.menteeName}>{mentee.name}</Text>
              <Text style={styles.menteeProgram}>{mentee.program}</Text>
              <View style={styles.progressContainer}>
                <View style={styles.progressBar}>
                  <View style={[styles.progressFill, { width: `${mentee.progress}%` }]} />
                </View>
                <Text style={styles.progressText}>{mentee.progress}%</Text>
              </View>
            </View>
            <View style={[styles.statusBadge, { backgroundColor: getStatusColor(mentee.status) + '20' }]}>
              <Text style={[styles.statusText, { color: getStatusColor(mentee.status) }]}>
                {mentee.status}
              </Text>
            </View>
          </View>
        ))}
      </View>

      {/* Upcoming Meetings */}
      <View style={styles.sectionCard}>
        <View style={styles.sectionHeader}>
          <Text style={styles.sectionTitle}>Upcoming Meetings</Text>
          <TouchableOpacity
            style={styles.sectionAction}
            onPress={() => setActiveTab('meetings')}
          >
            <Text style={styles.sectionActionText}>View All</Text>
            <Ionicons name="chevron-forward" size={16} color="#667eea" />
          </TouchableOpacity>
        </View>
        {(mentorData.meetings || []).filter(m => m.status === 'Scheduled').slice(0, 2).map((meeting) => (
          <View key={meeting.id} style={styles.meetingPreviewCard}>
            <View style={styles.meetingIcon}>
              <MaterialCommunityIcons name="video" size={20} color="#667eea" />
            </View>
            <View style={styles.meetingInfo}>
              <Text style={styles.meetingTitle}>{meeting.title}</Text>
              <Text style={styles.meetingMentee}>with {meeting.menteeName}</Text>
              <Text style={styles.meetingTime}>
                {formatDate(meeting.date)} at {meeting.time}
              </Text>
            </View>
            <TouchableOpacity
              style={styles.joinButton}
              onPress={() => Alert.alert('Meeting', `Joining ${meeting.platform} meeting...`)}
            >
              <Text style={styles.joinButtonText}>Join</Text>
            </TouchableOpacity>
          </View>
        ))}
      </View>

      {/* Quick Actions */}
      <View style={styles.sectionCard}>
        <Text style={styles.sectionTitle}>Quick Actions</Text>
        <View style={styles.quickActionsGrid}>
          <TouchableOpacity
            style={styles.quickActionCard}
            onPress={() => {
              setModalType('scheduleMeeting');
              setShowModal(true);
            }}
          >
            <MaterialCommunityIcons name="calendar-plus" size={32} color="#667eea" />
            <Text style={styles.quickActionText}>Schedule Meeting</Text>
          </TouchableOpacity>
          <TouchableOpacity
            style={styles.quickActionCard}
            onPress={() => {
              setModalType('addResource');
              setShowModal(true);
            }}
          >
            <MaterialCommunityIcons name="book-plus" size={32} color="#10B981" />
            <Text style={styles.quickActionText}>Add Resource</Text>
          </TouchableOpacity>
          <TouchableOpacity
            style={styles.quickActionCard}
            onPress={() => {
              setModalType('provideFeedback');
              setShowModal(true);
            }}
          >
            <MaterialCommunityIcons name="message-text" size={32} color="#F59E0B" />
            <Text style={styles.quickActionText}>Give Feedback</Text>
          </TouchableOpacity>
          <TouchableOpacity
            style={styles.quickActionCard}
            onPress={() => {
              setModalType('viewAnalytics');
              setShowModal(true);
            }}
          >
            <MaterialCommunityIcons name="chart-bar" size={32} color="#EF4444" />
            <Text style={styles.quickActionText}>View Analytics</Text>
          </TouchableOpacity>
        </View>
      </View>
    </ScrollView>
  );

  const renderMentees = () => (
    <View style={styles.content}>
      <View style={styles.searchContainer}>
        <View style={styles.searchInputContainer}>
          <Ionicons name="search" size={20} color="#8E8E93" />
          <TextInput
            style={styles.searchInput}
            placeholder="Search mentees..."
            value={searchQuery}
            onChangeText={setSearchQuery}
            placeholderTextColor="#8E8E93"
          />
        </View>
      </View>

      <FlatList
        data={(mentorData.mentees || []).filter(mentee => 
          String(mentee.name ?? '').toLowerCase().includes(searchQuery.toLowerCase()) ||
          String(mentee.program ?? '').toLowerCase().includes(searchQuery.toLowerCase())
        )}
        keyExtractor={(item) => item.id}
        renderItem={({ item }) => (
          <TouchableOpacity
            style={styles.menteeCard}
            onPress={() => {
              setSelectedItem(item);
              setModalType('menteeDetails');
              setShowModal(true);
            }}
          >
            <View style={styles.menteeCardHeader}>
              <Image source={{ uri: (item.avatar && item.avatar.startsWith('http')) ? item.avatar : undefined }} style={styles.menteeCardAvatar} />
              <View style={styles.menteeCardInfo}>
                <Text style={styles.menteeCardName}>{item.name}</Text>
                <Text style={styles.menteeCardProgram}>{item.program}</Text>
                <Text style={styles.menteeCardUniversity}>{item.university} • {item.year}</Text>
                <View style={styles.menteeCardMeta}>
                  <Text style={styles.menteeCardDates}>
                    {formatDate(item.startDate)} - {formatDate(item.endDate)}
                  </Text>
                </View>
              </View>
              <View style={[styles.statusBadge, { backgroundColor: getStatusColor(item.status) + '20' }]}>
                <Text style={[styles.statusText, { color: getStatusColor(item.status) }]}>
                  {item.status}
                </Text>
              </View>
            </View>

            <View style={styles.progressContainer}>
              <Text style={styles.progressLabel}>Overall Progress</Text>
              <View style={styles.progressBar}>
                <View style={[styles.progressFill, { width: `${item.progress}%` }]} />
              </View>
              <Text style={styles.progressText}>{item.progress}%</Text>
            </View>

            <View style={styles.skillsContainer}>
              <Text style={styles.skillsLabel}>Skills:</Text>
              <View style={styles.skillsRow}>
                {item.skills.slice(0, 3).map((skill, index) => (
                  <View key={index} style={styles.skillChip}>
                    <Text style={styles.skillChipText}>{skill}</Text>
                  </View>
                ))}
                {item.skills.length > 3 && (
                  <Text style={styles.moreSkills}>+{item.skills.length - 3} more</Text>
                )}
              </View>
            </View>

            <View style={styles.menteeCardFooter}>
              <View style={styles.performanceIndicator}>
                <MaterialCommunityIcons name="star" size={16} color="#F59E0B" />
                <Text style={styles.performanceText}>{item.performance.overall.toFixed(1)}</Text>
              </View>
              <Text style={styles.lastMeetingText}>
                Last meeting: {formatDate(item.lastMeeting)}
              </Text>
            </View>
          </TouchableOpacity>
        )}
        showsVerticalScrollIndicator={false}
        refreshControl={
          <RefreshControl refreshing={refreshing} onRefresh={onRefresh} />
        }
        ListEmptyComponent={() => (
          <View style={styles.emptyState}>
            <MaterialCommunityIcons name="account-search" size={64} color="#C7C7CC" />
            <Text style={styles.emptyStateTitle}>No Mentees Found</Text>
            <Text style={styles.emptyStateText}>
              Your mentees will appear here once assigned
            </Text>
          </View>
        )}
      />
    </View>
  );

  const renderMeetings = () => (
    <View style={styles.content}>
      <View style={styles.meetingsHeader}>
        <Text style={styles.meetingsTitle}>Meetings</Text>
        <TouchableOpacity
          style={styles.addMeetingButton}
          onPress={() => {
            setModalType('scheduleMeeting');
            setShowModal(true);
          }}
        >
          <Ionicons name="add" size={20} color="#FFFFFF" />
          <Text style={styles.addMeetingButtonText}>Schedule</Text>
        </TouchableOpacity>
      </View>

      <FlatList
        data={(mentorData.meetings || []).sort((a, b) => new Date(b.date) - new Date(a.date))}
        keyExtractor={(item) => item.id}
        renderItem={({ item }) => (
          <TouchableOpacity
            style={styles.meetingCard}
            onPress={() => {
              setSelectedItem(item);
              setModalType('meetingDetails');
              setShowModal(true);
            }}
          >
            <View style={styles.meetingCardHeader}>
              <View style={styles.meetingTypeIcon}>
                <MaterialCommunityIcons 
                  name={item.type === 'Virtual' ? 'video' : 'account-group'} 
                  size={20} 
                  color="#667eea" 
                />
              </View>
              <View style={styles.meetingCardInfo}>
                <Text style={styles.meetingCardTitle}>{item.title}</Text>
                <Text style={styles.meetingCardMentee}>with {item.menteeName}</Text>
                <Text style={styles.meetingCardDateTime}>
                  {formatDate(item.date)} at {item.time} ({item.duration} min)
                </Text>
                {item.platform && (
                  <Text style={styles.meetingCardPlatform}>via {item.platform}</Text>
                )}
              </View>
              <View style={[styles.statusBadge, { backgroundColor: getStatusColor(item.status) + '20' }]}>
                <Text style={[styles.statusText, { color: getStatusColor(item.status) }]}>
                  {item.status}
                </Text>
              </View>
            </View>

            {item.agenda && item.agenda.length > 0 && (
              <View style={styles.agendaPreview}>
                <Text style={styles.agendaLabel}>Agenda:</Text>
                <Text style={styles.agendaText} numberOfLines={2}>
                  {item.agenda.slice(0, 2).join(' • ')}
                  {item.agenda.length > 2 && '...'}
                </Text>
              </View>
            )}

            {item.status === 'Scheduled' && (
              <View style={styles.meetingActions}>
                <TouchableOpacity
                  style={styles.joinMeetingButton}
                  onPress={() => Alert.alert('Meeting', `Joining ${item.platform} meeting...`)}
                >
                  <MaterialCommunityIcons name="video" size={16} color="#FFFFFF" />
                  <Text style={styles.joinMeetingButtonText}>Join Meeting</Text>
                </TouchableOpacity>
                <TouchableOpacity
                  style={styles.editMeetingButton}
                  onPress={() => {
                    setSelectedItem(item);
                    setModalType('editMeeting');
                    setShowModal(true);
                  }}
                >
                  <Ionicons name="pencil" size={16} color="#667eea" />
                </TouchableOpacity>
              </View>
            )}
          </TouchableOpacity>
        )}
        showsVerticalScrollIndicator={false}
        refreshControl={
          <RefreshControl refreshing={refreshing} onRefresh={onRefresh} />
        }
        ListEmptyComponent={() => (
          <View style={styles.emptyState}>
            <MaterialCommunityIcons name="calendar-blank" size={64} color="#C7C7CC" />
            <Text style={styles.emptyStateTitle}>No Meetings Scheduled</Text>
            <Text style={styles.emptyStateText}>
              Schedule meetings with your mentees to get started
            </Text>
            <TouchableOpacity
              style={styles.emptyStateButton}
              onPress={() => {
                setModalType('scheduleMeeting');
                setShowModal(true);
              }}
            >
              <Text style={styles.emptyStateButtonText}>Schedule Meeting</Text>
            </TouchableOpacity>
          </View>
        )}
      />
    </View>
  );

  const renderResources = () => (
    <View style={styles.content}>
      <View style={styles.resourcesHeader}>
        <Text style={styles.resourcesTitle}>Learning Resources</Text>
        <TouchableOpacity
          style={styles.addResourceButton}
          onPress={() => {
            setModalType('addResource');
            setShowModal(true);
          }}
        >
          <Ionicons name="add" size={20} color="#FFFFFF" />
          <Text style={styles.addResourceButtonText}>Add</Text>
        </TouchableOpacity>
      </View>

      <FlatList
        data={(mentorData.resources || [])}
        keyExtractor={(item) => item.id}
        renderItem={({ item }) => (
          <View style={styles.resourceCard}>
            <View style={styles.resourceHeader}>
              <View style={styles.resourceTypeIcon}>
                <MaterialCommunityIcons 
                  name={
                    item.type === 'Document' ? 'file-document' :
                    item.type === 'Video Course' ? 'play-circle' :
                    item.type === 'Tutorial' ? 'school' : 'web'
                  } 
                  size={24} 
                  color="#667eea" 
                />
              </View>
              <View style={styles.resourceInfo}>
                <Text style={styles.resourceTitle}>{item.title}</Text>
                <Text style={styles.resourceCategory}>{item.category} • {item.type}</Text>
                <Text style={styles.resourceDescription} numberOfLines={2}>
                  {item.description}
                </Text>
              </View>
            </View>

            <View style={styles.resourceTags}>
              {item.tags.slice(0, 3).map((tag, index) => (
                <View key={index} style={styles.resourceTag}>
                  <Text style={styles.resourceTagText}>{tag}</Text>
                </View>
              ))}
              {item.tags.length > 3 && (
                <Text style={styles.moreTags}>+{item.tags.length - 3} more</Text>
              )}
            </View>

            <View style={styles.resourceFooter}>
              <Text style={styles.sharedWithText}>
                Shared with {item.sharedWith.length} mentee{item.sharedWith.length !== 1 ? 's' : ''}
              </Text>
              <View style={styles.resourceActions}>
                <TouchableOpacity
                  style={styles.shareButton}
                  onPress={() => {
                    setSelectedItem(item);
                    setModalType('shareResource');
                    setShowModal(true);
                  }}
                >
                  <Ionicons name="share" size={16} color="#667eea" />
                </TouchableOpacity>
                <TouchableOpacity
                  style={styles.openButton}
                  onPress={() => Alert.alert('Resource', `Opening ${item.title}...`)}
                >
                  <Ionicons name="open" size={16} color="#667eea" />
                </TouchableOpacity>
              </View>
            </View>
          </View>
        )}
        showsVerticalScrollIndicator={false}
        refreshControl={
          <RefreshControl refreshing={refreshing} onRefresh={onRefresh} />
        }
        ListEmptyComponent={() => (
          <View style={styles.emptyState}>
            <MaterialCommunityIcons name="book-open-variant" size={64} color="#C7C7CC" />
            <Text style={styles.emptyStateTitle}>No Resources Added</Text>
            <Text style={styles.emptyStateText}>
              Add learning resources to share with your mentees
            </Text>
            <TouchableOpacity
              style={styles.emptyStateButton}
              onPress={() => {
                setModalType('addResource');
                setShowModal(true);
              }}
            >
              <Text style={styles.emptyStateButtonText}>Add Resource</Text>
            </TouchableOpacity>
          </View>
        )}
      />
    </View>
  );

  const renderModal = () => {
    switch (modalType) {
      case 'menteeDetails':
        return renderMenteeDetailsModal();
      case 'meetingDetails':
        return renderMeetingDetailsModal();
      case 'scheduleMeeting':
        return renderScheduleMeetingModal();
      case 'addResource':
        return renderAddResourceModal();
      case 'notifications':
        return renderNotificationsModal();
      case 'editProfile':
        return renderEditProfileModal();
      case 'provideFeedback':
        return renderProvideFeedbackModal();
      case 'viewAnalytics':
        return renderViewAnalyticsModal();
      case 'shareResource':
        return renderShareResourceModal();
      default:
        return null;
    }
  };

  const renderMeetingDetailsModal = () => {
    if (!selectedItem) return null;

    return (
      <View style={styles.modalContent}>
        <View style={styles.modalHeader}>
          <TouchableOpacity
            style={styles.modalCloseButton}
            onPress={() => setShowModal(false)}
          >
            <Ionicons name="close" size={24} color="#8E8E93" />
          </TouchableOpacity>
          <Text style={styles.modalTitle}>Meeting Details</Text>
          <View style={{ width: 40 }} />
        </View>
        <ScrollView style={styles.modalBody}>
          <Text style={styles.meetingTitle}>{selectedItem.title}</Text>
          <View style={styles.meetingInfoRow}>
            <Ionicons name="person-outline" size={20} color="#8E8E93" />
            <Text style={styles.meetingInfoText}>With: {selectedItem.menteeName}</Text>
          </View>
          <View style={styles.meetingInfoRow}>
            <Ionicons name="calendar-outline" size={20} color="#8E8E93" />
            <Text style={styles.meetingInfoText}>{new Date(selectedItem.date).toLocaleDateString("en-US", { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</Text>
          </View>
          <View style={styles.meetingInfoRow}>
            <Ionicons name="time-outline" size={20} color="#8E8E93" />
            <Text style={styles.meetingInfoText}>{selectedItem.time}</Text>
          </View>
          <View style={styles.meetingInfoRow}>
            <Ionicons name="location-outline" size={20} color="#8E8E93" />
            <Text style={styles.meetingInfoText}>{selectedItem.location}</Text>
          </View>
          <View style={styles.meetingInfoRow}>
            <Ionicons name="flag-outline" size={20} color="#8E8E93" />
            <Text style={styles.meetingInfoText}>Status: {selectedItem.status}</Text>
          </View>
          
          <View style={styles.meetingSection}>
            <Text style={styles.meetingSectionTitle}>Agenda</Text>
            {selectedItem.agenda.map((item, index) => (
              <Text key={index} style={styles.meetingAgendaItem}>- {item}</Text>
            ))}
          </View>
          
          <View style={styles.meetingSection}>
            <Text style={styles.meetingSectionTitle}>Summary</Text>
            <Text style={styles.meetingSummary}>{selectedItem.summary}</Text>
          </View>

          <View style={styles.meetingSection}>
            <Text style={styles.meetingSectionTitle}>Action Items</Text>
            {selectedItem.actionItems.map((item, index) => (
              <Text key={index} style={styles.meetingActionItem}>- {item}</Text>
            ))}
          </View>
        </ScrollView>
      </View>
    );
  };

  const renderMenteeDetailsModal = () => (
    <View style={styles.modalContent}>
      <View style={styles.modalHeader}>
        <TouchableOpacity
          style={styles.modalCloseButton}
          onPress={() => setShowModal(false)}
        >
          <Ionicons name="close" size={24} color="#8E8E93" />
        </TouchableOpacity>
        <Text style={styles.modalTitle}>Mentee Details</Text>
        <TouchableOpacity
          style={styles.modalActionButton}
          onPress={() => {
            setModalType('provideFeedback');
          }}
        >
          <Text style={styles.modalActionText}>Feedback</Text>
        </TouchableOpacity>
      </View>

      <ScrollView style={styles.modalBody} showsVerticalScrollIndicator={false}>
        {selectedItem && (
          <View style={styles.detailsContainer}>
            <View style={styles.menteeDetailsHeader}>
              <Image source={{ uri: (selectedItem.avatar && selectedItem.avatar.startsWith('http')) ? selectedItem.avatar : undefined }} style={styles.menteeDetailsAvatar} />
              <View style={styles.menteeDetailsInfo}>
                <Text style={styles.menteeDetailsName}>{selectedItem.name}</Text>
                <Text style={styles.menteeDetailsProgram}>{selectedItem.program}</Text>
                <Text style={styles.menteeDetailsUniversity}>
                  {selectedItem.university} • {selectedItem.major} • {selectedItem.year}
                </Text>
                <View style={styles.contactInfo}>
                  <Text style={styles.contactText}>{selectedItem.email}</Text>
                </View>
              </View>
            </View>

            <View style={styles.detailsSection}>
              <Text style={styles.detailsSectionTitle}>Progress Overview</Text>
              <View style={styles.progressContainer}>
                <View style={styles.progressBar}>
                  <View style={[styles.progressFill, { width: `${selectedItem.progress}%` }]} />
                </View>
                <Text style={styles.progressText}>{selectedItem.progress}%</Text>
              </View>
              <Text style={styles.progressDates}>
                {formatDate(selectedItem.startDate)} - {formatDate(selectedItem.endDate)}
              </Text>
            </View>

            <View style={styles.detailsSection}>
              <Text style={styles.detailsSectionTitle}>Performance Metrics</Text>
              <View style={styles.performanceGrid}>
                {Object.entries(selectedItem.performance).filter(([key]) => key !== 'overall').map(([category, rating]) => (
                  <View key={category} style={styles.performanceItem}>
                    <Text style={styles.performanceCategory}>
                      {category.charAt(0).toUpperCase() + category.slice(1)}
                    </Text>
                    <View style={styles.ratingStars}>
                      {[1, 2, 3, 4, 5].map((star) => (
                        <MaterialCommunityIcons
                          key={star}
                          name="star"
                          size={16}
                          color={star <= rating ? '#F59E0B' : '#E5E5EA'}
                        />
                      ))}
                    </View>
                    <Text style={styles.ratingValue}>{rating.toFixed(1)}</Text>
                  </View>
                ))}
              </View>
            </View>

            <View style={styles.detailsSection}>
              <Text style={styles.detailsSectionTitle}>Goals</Text>
              {selectedItem.goals.map((goal, index) => (
                <View key={index} style={styles.goalItem}>
                  <MaterialCommunityIcons name="target" size={16} color="#667eea" />
                  <Text style={styles.goalText}>{goal}</Text>
                </View>
              ))}
            </View>

            <View style={styles.detailsSection}>
              <Text style={styles.detailsSectionTitle}>Achievements</Text>
              {selectedItem.achievements.map((achievement, index) => (
                <View key={index} style={styles.achievementItem}>
                  <MaterialCommunityIcons name="trophy" size={16} color="#F59E0B" />
                  <Text style={styles.achievementText}>{achievement}</Text>
                </View>
              ))}
            </View>

            <View style={styles.detailsSection}>
              <Text style={styles.detailsSectionTitle}>Skills</Text>
              <View style={styles.skillsGrid}>
                {selectedItem.skills.map((skill, index) => (
                  <View key={index} style={styles.skillChip}>
                    <Text style={styles.skillChipText}>{skill}</Text>
                  </View>
                ))}
              </View>
            </View>

            {selectedItem.notes && (
              <View style={styles.detailsSection}>
                <Text style={styles.detailsSectionTitle}>Notes</Text>
                <Text style={styles.detailsDescription}>{selectedItem.notes}</Text>
              </View>
            )}
          </View>
        )}
      </ScrollView>
    </View>
  );

  const renderScheduleMeetingModal = () => (
    <View style={styles.modalContent}>
      <View style={styles.modalHeader}>
        <TouchableOpacity
          style={styles.modalCloseButton}
          onPress={() => setShowModal(false)}
        >
          <Ionicons name="close" size={24} color="#8E8E93" />
        </TouchableOpacity>
        <Text style={styles.modalTitle}>Schedule Meeting</Text>
        <TouchableOpacity
          style={styles.modalActionButton}
          onPress={() => {
            Alert.alert('Success', 'Meeting scheduled successfully!');
            setShowModal(false);
          }}
        >
          <Text style={styles.modalActionText}>Schedule</Text>
        </TouchableOpacity>
      </View>

      <ScrollView style={styles.modalBody} showsVerticalScrollIndicator={false}>
        <View style={styles.formGroup}>
          <Text style={styles.formLabel}>Mentee *</Text>
          <TouchableOpacity style={styles.formSelect}>
            <Text style={styles.formSelectText}>Select Mentee</Text>
            <Ionicons name="chevron-down" size={20} color="#8E8E93" />
          </TouchableOpacity>
        </View>

        <View style={styles.formGroup}>
          <Text style={styles.formLabel}>Meeting Title *</Text>
          <TextInput
            style={styles.formInput}
            value={newMeeting.title}
            onChangeText={(text) => setNewMeeting({...newMeeting, title: text})}
            placeholder="Enter meeting title"
            placeholderTextColor="#C7C7CC"
          />
        </View>

        <View style={styles.formRow}>
          <View style={styles.formGroupHalf}>
            <Text style={styles.formLabel}>Date *</Text>
            <TextInput
              style={styles.formInput}
              value={newMeeting.date}
              onChangeText={(text) => setNewMeeting({...newMeeting, date: text})}
              placeholder="YYYY-MM-DD"
              placeholderTextColor="#C7C7CC"
            />
          </View>
          <View style={styles.formGroupHalf}>
            <Text style={styles.formLabel}>Time *</Text>
            <TextInput
              style={styles.formInput}
              value={newMeeting.time}
              onChangeText={(text) => setNewMeeting({...newMeeting, time: text})}
              placeholder="HH:MM AM/PM"
              placeholderTextColor="#C7C7CC"
            />
          </View>
        </View>

        <View style={styles.formRow}>
          <View style={styles.formGroupHalf}>
            <Text style={styles.formLabel}>Duration (minutes)</Text>
            <TextInput
              style={styles.formInput}
              value={newMeeting.duration.toString()}
              onChangeText={(text) => setNewMeeting({...newMeeting, duration: parseInt(text) || 60})}
              placeholder="60"
              placeholderTextColor="#C7C7CC"
              keyboardType="numeric"
            />
          </View>
          <View style={styles.formGroupHalf}>
            <Text style={styles.formLabel}>Platform</Text>
            <TouchableOpacity style={styles.formSelect}>
              <Text style={styles.formSelectText}>{newMeeting.platform}</Text>
              <Ionicons name="chevron-down" size={20} color="#8E8E93" />
            </TouchableOpacity>
          </View>
        </View>

        <View style={styles.formGroup}>
          <Text style={styles.formLabel}>Agenda Items</Text>
          <TextInput
            style={[styles.formInput, styles.textArea]}
            placeholder="Enter agenda items (one per line)"
            placeholderTextColor="#C7C7CC"
            multiline
            numberOfLines={4}
          />
        </View>
      </ScrollView>
    </View>
  );

  const renderNotificationsModal = () => (
    <View style={styles.modalContent}>
      <View style={styles.modalHeader}>
        <TouchableOpacity
          style={styles.modalCloseButton}
          onPress={() => setShowModal(false)}
        >
          <Ionicons name="close" size={24} color="#8E8E93" />
        </TouchableOpacity>
        <Text style={styles.modalTitle}>Notifications</Text>
        <TouchableOpacity
          style={styles.modalActionButton}
          onPress={() => {
            const updatedData = {
              ...mentorData,
              notifications: (mentorData.notifications || []).map(n => ({ ...n, read: true }))
            };
            setMentorData(updatedData);
            saveMentorData(updatedData);
          }}
        >
          <Text style={styles.modalActionText}>Mark All Read</Text>
        </TouchableOpacity>
      </View>

      <ScrollView style={styles.modalBody}>
        {(mentorData.notifications || []).map((notification) => (
          <View key={notification.id} style={[styles.notificationItem, !notification.read && styles.unreadNotification]}>
            <View style={styles.notificationIcon}>
              <MaterialCommunityIcons 
                name={notification.type === 'meeting' ? 'calendar' : 'message'} 
                size={20} 
                color="#667eea" 
              />
            </View>
            <View style={styles.notificationContent}>
              <Text style={styles.notificationTitle}>{notification.title}</Text>
              <Text style={styles.notificationMessage}>{notification.message}</Text>
              <Text style={styles.notificationDate}>{formatDate(notification.date)}</Text>
            </View>
            {!notification.read && <View style={styles.unreadDot} />}
          </View>
        ))}
      </ScrollView>
    </View>
  );

  const renderAddResourceModal = () => (
    <View style={styles.modalContent}>
      <View style={styles.modalHeader}>
        <TouchableOpacity
          style={styles.modalCloseButton}
          onPress={() => setShowModal(false)}
        >
          <Ionicons name="close" size={24} color="#8E8E93" />
        </TouchableOpacity>
        <Text style={styles.modalTitle}>Add Resource</Text>
        <View style={{ width: 40 }} />
      </View>
      <ScrollView style={styles.modalBody}>
        <View style={styles.formGroup}>
          <Text style={styles.formLabel}>Resource Title</Text>
          <TextInput
            style={styles.formInput}
            placeholder="Enter resource title"
            placeholderTextColor="#8E8E93"
          />
        </View>
        <View style={styles.formGroup}>
          <Text style={styles.formLabel}>Resource Type</Text>
          <View style={styles.resourceTypeContainer}>
            {['Article', 'Video', 'Book', 'Course', 'Tool'].map((type) => (
              <TouchableOpacity key={type} style={styles.resourceTypeButton}>
                <Text style={styles.resourceTypeText}>{type}</Text>
              </TouchableOpacity>
            ))}
          </View>
        </View>
        <View style={styles.formGroup}>
          <Text style={styles.formLabel}>Description</Text>
          <TextInput
            style={[styles.formInput, styles.textArea]}
            placeholder="Enter resource description"
            placeholderTextColor="#8E8E93"
            multiline
            numberOfLines={4}
          />
        </View>
        <View style={styles.formGroup}>
          <Text style={styles.formLabel}>URL</Text>
          <TextInput
            style={styles.formInput}
            placeholder="Enter resource URL"
            placeholderTextColor="#8E8E93"
          />
        </View>
        <TouchableOpacity style={styles.submitButton}>
          <Text style={styles.submitButtonText}>Add Resource</Text>
        </TouchableOpacity>
      </ScrollView>
    </View>
  );

  const renderEditProfileModal = () => (
    <View style={styles.modalContent}>
      <View style={styles.modalHeader}>
        <TouchableOpacity
          style={styles.modalCloseButton}
          onPress={() => setShowModal(false)}
        >
          <Ionicons name="close" size={24} color="#8E8E93" />
        </TouchableOpacity>
        <Text style={styles.modalTitle}>Edit Profile</Text>
        <View style={{ width: 40 }} />
      </View>
      <ScrollView style={styles.modalBody}>
        <View style={styles.formGroup}>
          <Text style={styles.formLabel}>Name</Text>
          <TextInput
            style={styles.formInput}
            value={(mentorData.profile || {}).name}
            placeholder="Enter your name"
            placeholderTextColor="#8E8E93"
          />
        </View>
        <View style={styles.formGroup}>
          <Text style={styles.formLabel}>Title</Text>
          <TextInput
            style={styles.formInput}
            value={(mentorData.profile || {}).title}
            placeholder="Enter your title"
            placeholderTextColor="#8E8E93"
          />
        </View>
        <View style={styles.formGroup}>
          <Text style={styles.formLabel}>Bio</Text>
          <TextInput
            style={[styles.formInput, styles.textArea]}
            value={(mentorData.profile || {}).bio || ''}
            placeholder="Tell us about yourself"
            placeholderTextColor="#8E8E93"
            multiline
            numberOfLines={4}
          />
        </View>
        <TouchableOpacity style={styles.submitButton}>
          <Text style={styles.submitButtonText}>Save Changes</Text>
        </TouchableOpacity>
      </ScrollView>
    </View>
  );

  const renderProvideFeedbackModal = () => {
    if (!selectedItem) return null;
    
    return (
      <View style={styles.modalContent}>
        <View style={styles.modalHeader}>
          <TouchableOpacity
            style={styles.modalCloseButton}
            onPress={() => setShowModal(false)}
          >
            <Ionicons name="close" size={24} color="#8E8E93" />
          </TouchableOpacity>
          <Text style={styles.modalTitle}>Provide Feedback</Text>
          <View style={{ width: 40 }} />
        </View>
        <ScrollView style={styles.modalBody}>
          <Text style={styles.feedbackMentee}>Feedback for {selectedItem.name}</Text>
          
          <View style={styles.ratingSection}>
            <Text style={styles.ratingLabel}>Technical Skills</Text>
            <View style={styles.ratingStars}>
              {[1, 2, 3, 4, 5].map((star) => (
                <TouchableOpacity key={star}>
                  <Ionicons
                    name={star <= 4 ? 'star' : 'star-outline'}
                    size={24}
                    color="#FFD700"
                  />
                </TouchableOpacity>
              ))}
            </View>
          </View>
          
          <View style={styles.formGroup}>
            <Text style={styles.formLabel}>Comments</Text>
            <TextInput
              style={[styles.formInput, styles.textArea]}
              placeholder="Provide detailed feedback..."
              placeholderTextColor="#8E8E93"
              multiline
              numberOfLines={6}
            />
          </View>
          
          <TouchableOpacity style={styles.submitButton}>
            <Text style={styles.submitButtonText}>Submit Feedback</Text>
          </TouchableOpacity>
        </ScrollView>
      </View>
    );
  };

  const renderViewAnalyticsModal = () => (
    <View style={styles.modalContent}>
      <View style={styles.modalHeader}>
        <TouchableOpacity
          style={styles.modalCloseButton}
          onPress={() => setShowModal(false)}
        >
          <Ionicons name="close" size={24} color="#8E8E93" />
        </TouchableOpacity>
        <Text style={styles.modalTitle}>Analytics Dashboard</Text>
        <View style={{ width: 40 }} />
      </View>
      <ScrollView style={styles.modalBody}>
        <View style={styles.analyticsCard}>
          <Text style={styles.analyticsTitle}>Mentoring Overview</Text>
          <View style={styles.analyticsRow}>
            <View style={styles.analyticsItem}>
              <Text style={styles.analyticsNumber}>24</Text>
              <Text style={styles.analyticsLabel}>Total Mentored</Text>
            </View>
            <View style={styles.analyticsItem}>
              <Text style={styles.analyticsNumber}>3</Text>
              <Text style={styles.analyticsLabel}>Current Mentees</Text>
            </View>
          </View>
        </View>
        
        <View style={styles.analyticsCard}>
          <Text style={styles.analyticsTitle}>Performance Metrics</Text>
          <View style={styles.metricRow}>
            <Text style={styles.metricLabel}>Average Rating</Text>
            <Text style={styles.metricValue}>4.9/5.0</Text>
          </View>
          <View style={styles.metricRow}>
            <Text style={styles.metricLabel}>Completion Rate</Text>
            <Text style={styles.metricValue}>92%</Text>
          </View>
        </View>
      </ScrollView>
    </View>
  );

  const renderShareResourceModal = () => {
    if (!selectedItem) return null;
    
    return (
      <View style={styles.modalContent}>
        <View style={styles.modalHeader}>
          <TouchableOpacity
            style={styles.modalCloseButton}
            onPress={() => setShowModal(false)}
          >
            <Ionicons name="close" size={24} color="#8E8E93" />
          </TouchableOpacity>
          <Text style={styles.modalTitle}>Share Resource</Text>
          <View style={{ width: 40 }} />
        </View>
        <ScrollView style={styles.modalBody}>
          <View style={styles.resourcePreview}>
            <View style={styles.resourceTypeIcon}>
              <MaterialCommunityIcons 
                name={
                  selectedItem.type === 'Document' ? 'file-document' :
                  selectedItem.type === 'Video Course' ? 'play-circle' :
                  selectedItem.type === 'Tutorial' ? 'school' : 'web'
                } 
                size={32} 
                color="#667eea" 
              />
            </View>
            <View style={styles.resourcePreviewInfo}>
              <Text style={styles.resourcePreviewTitle}>{selectedItem.title}</Text>
              <Text style={styles.resourcePreviewCategory}>{selectedItem.category} • {selectedItem.type}</Text>
            </View>
          </View>
          
          <View style={styles.shareSection}>
            <Text style={styles.shareSectionTitle}>Share with Mentees</Text>
            {(mentorData.mentees || []).map((mentee) => {
              const isShared = selectedItem.sharedWith.includes(mentee.id);
              return (
                <TouchableOpacity 
                  key={mentee.id} 
                  style={[styles.menteeShareItem, isShared && styles.menteeShareItemSelected]}
                  onPress={() => {
                    // Toggle share status
                    Alert.alert(
                      isShared ? 'Remove Access' : 'Share Resource',
                      `${isShared ? 'Remove' : 'Grant'} access to ${selectedItem.title} for ${mentee.name}?`,
                      [
                        { text: 'Cancel', style: 'cancel' },
                        { 
                          text: isShared ? 'Remove' : 'Share', 
                          onPress: () => {
                            // Here you would update the resource sharing
                            Alert.alert('Success', `Resource ${isShared ? 'unshared from' : 'shared with'} ${mentee.name}`);
                          }
                        }
                      ]
                    );
                  }}
                >
                  <Image source={{ uri: (mentee.avatar && mentee.avatar.startsWith('http')) ? mentee.avatar : undefined }} style={styles.menteeShareAvatar} />
                  <View style={styles.menteeShareInfo}>
                    <Text style={styles.menteeShareName}>{mentee.name}</Text>
                    <Text style={styles.menteeShareProgram}>{mentee.program}</Text>
                  </View>
                  <View style={styles.menteeShareStatus}>
                    <Ionicons 
                      name={isShared ? 'checkmark-circle' : 'add-circle-outline'} 
                      size={24} 
                      color={isShared ? '#34C759' : '#8E8E93'} 
                    />
                  </View>
                </TouchableOpacity>
              );
            })}
          </View>
          
          <View style={styles.shareOptions}>
            <TouchableOpacity style={styles.shareOptionButton}>
              <Ionicons name="link" size={20} color="#667eea" />
              <Text style={styles.shareOptionText}>Copy Link</Text>
            </TouchableOpacity>
            <TouchableOpacity style={styles.shareOptionButton}>
              <Ionicons name="mail" size={20} color="#667eea" />
              <Text style={styles.shareOptionText}>Send via Email</Text>
            </TouchableOpacity>
          </View>
        </ScrollView>
      </View>
    );
  };


  // ══ PROGRESS TAB ══
  const renderProgressTab = () => (<ScrollView style={{ flex: 1, padding: 16 }} refreshControl={<RefreshControl refreshing={refreshing} onRefresh={onRefresh} />}>
    <Text style={{ fontSize: 18, fontWeight: 'bold', color: '#1F2937', marginBottom: 16 }}>Mentee Progress</Text>
    {(mentorData.mentees || []).map((m, i) => (<View key={i} style={{ backgroundColor: '#FFF', padding: 14, borderRadius: 10, borderWidth: 1, borderColor: '#E5E7EB', marginBottom: 8 }}>
      <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 8 }}>{m.avatar ? <Image source={{ uri: (m.avatar && m.avatar.startsWith('http')) ? m.avatar : undefined }} style={{ width: 36, height: 36, borderRadius: 18, marginRight: 10 }} /> : null}
        <View style={{ flex: 1 }}><Text style={{ fontWeight: '600', color: '#1F2937' }}>{m.name}</Text><Text style={{ fontSize: 12, color: '#6B7280' }}>{m.role || 'Mentee'}</Text></View>
        <Text style={{ fontSize: 16, fontWeight: '700', color: (m.progress || 0) >= 70 ? '#10B981' : '#F59E0B' }}>{m.progress || 0}%</Text></View>
      <View style={{ height: 6, backgroundColor: '#E5E7EB', borderRadius: 3, overflow: 'hidden' }}><View style={{ height: '100%', width: (m.progress || 0) + '%', backgroundColor: (m.progress || 0) >= 70 ? '#10B981' : '#F59E0B', borderRadius: 3 }} /></View>
      <View style={{ flexDirection: 'row', gap: 6, marginTop: 8 }}>
        <TouchableOpacity style={{ flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center', backgroundColor: '#667eea15', paddingVertical: 8, borderRadius: 8 }} onPress={() => handleEvaluateMentee(m)}><MaterialCommunityIcons name="clipboard-check" size={14} color="#667eea" /><Text style={{ marginLeft: 4, fontSize: 11, fontWeight: '600', color: '#667eea' }}>Evaluate</Text></TouchableOpacity>
        <TouchableOpacity style={{ flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center', backgroundColor: '#10B98115', paddingVertical: 8, borderRadius: 8 }} onPress={() => handleMakeOffer(m)}><MaterialCommunityIcons name="file-document" size={14} color="#10B981" /><Text style={{ marginLeft: 4, fontSize: 11, fontWeight: '600', color: '#10B981' }}>Offer</Text></TouchableOpacity></View>
    </View>))}<View style={{ height: 40 }} /></ScrollView>);

  // ══ EVALUATE TAB ══
  const renderEvaluateTab = () => (<ScrollView style={{ flex: 1, padding: 16 }}>
    <Text style={{ fontSize: 18, fontWeight: 'bold', color: '#1F2937', marginBottom: 16 }}>Evaluate Mentees</Text>
    {(mentorData.mentees || []).map((m, i) => (<TouchableOpacity key={i} style={{ backgroundColor: '#FFF', padding: 14, borderRadius: 10, borderWidth: 1, borderColor: '#E5E7EB', marginBottom: 8, flexDirection: 'row', alignItems: 'center' }} onPress={() => handleEvaluateMentee(m)}>
      <View style={{ width: 40, height: 40, borderRadius: 20, backgroundColor: '#7C3AED', justifyContent: 'center', alignItems: 'center', marginRight: 12 }}><MaterialCommunityIcons name="clipboard-check" size={20} color="#FFF" /></View>
      <View style={{ flex: 1 }}><Text style={{ fontWeight: '600', color: '#1F2937' }}>{m.name}</Text><Text style={{ fontSize: 12, color: '#6B7280' }}>{m.role || 'Mentee'}</Text></View>
      <MaterialCommunityIcons name="chevron-right" size={20} color="#9CA3AF" /></TouchableOpacity>))}
    {[{ l: 'Full Evaluation', i: 'clipboard-check', c: '#7C3AED', fn: () => navigation?.navigate('EvaluationAssessmentScreen', { companyLogo, companyName }) },
      { l: 'Employee Management', i: 'account-group', c: '#0e4e96', fn: handleViewEmployees },
      { l: 'Internship Programs', i: 'school', c: '#B45309', fn: handleViewInternships },
    ].map((a, i) => (<TouchableOpacity key={i} style={{ flexDirection: 'row', alignItems: 'center', backgroundColor: '#FFF', padding: 14, borderRadius: 10, borderWidth: 1, borderColor: '#E5E7EB', marginBottom: 8 }} onPress={a.fn}>
      <View style={{ width: 40, height: 40, borderRadius: 20, backgroundColor: a.c + '15', justifyContent: 'center', alignItems: 'center', marginRight: 12 }}><MaterialCommunityIcons name={a.i} size={20} color={a.c} /></View>
      <Text style={{ flex: 1, fontSize: 14, fontWeight: '600', color: '#1F2937' }}>{a.l}</Text><MaterialCommunityIcons name="chevron-right" size={20} color="#9CA3AF" /></TouchableOpacity>))}
  </ScrollView>);

  // ══ REPORTS TAB ══
  const renderReportsTab = () => (<ScrollView style={{ flex: 1, padding: 16 }}>
    <Text style={{ fontSize: 18, fontWeight: 'bold', color: '#1F2937', marginBottom: 16 }}>Reports</Text>
    <View style={{ flexDirection: 'row', flexWrap: 'wrap' }}>{[{ l: 'Mentees', v: (mentorData.mentees || []).length, c: '#667eea', i: 'account-group' }, { l: 'Meetings', v: (mentorData.meetings || []).length, c: '#10B981', i: 'calendar-clock' }, { l: 'Resources', v: (mentorData.resources || []).length, c: '#F59E0B', i: 'book-open-variant' }, { l: 'Rating', v: (mentorData.profile || {}).rating || 0, c: '#8B5CF6', i: 'star' }].map((m, i) => (
      <View key={i} style={{ width: (Dimensions.get('window').width - 48) / 2, backgroundColor: '#F9FAFB', borderRadius: 10, padding: 14, alignItems: 'center', margin: 4 }}><MaterialCommunityIcons name={m.i} size={22} color={m.c} /><Text style={{ fontSize: 18, fontWeight: 'bold', color: m.c, marginTop: 4 }}>{m.v}</Text><Text style={{ fontSize: 12, color: '#6B7280', marginTop: 2 }}>{m.l}</Text></View>))}</View>
    <TouchableOpacity style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'center', backgroundColor: '#667eea', borderRadius: 10, padding: 14, marginTop: 16 }} onPress={() => { const S = require('react-native').Share; S.share({ message: JSON.stringify({ mentor: (mentorData.profile || {}).name, mentees: (mentorData.mentees || []).length, meetings: (mentorData.meetings || []).length, rating: (mentorData.profile || {}).rating }, null, 2) }); }}>
      <MaterialCommunityIcons name="export" size={18} color="#FFF" /><Text style={{ color: '#FFF', fontWeight: '700', fontSize: 15, marginLeft: 8 }}>Export Report</Text></TouchableOpacity>
  </ScrollView>);

  // ══ SETTINGS TAB ══
  const renderSettingsTab = () => (<ScrollView style={{ flex: 1, padding: 16 }}>
    <Text style={{ fontSize: 18, fontWeight: 'bold', color: '#1F2937', marginBottom: 16 }}>Settings</Text>
    <View style={{ backgroundColor: '#FFF', padding: 16, borderRadius: 12, borderWidth: 1, borderColor: '#E5E7EB' }}>
      {[{ l: 'Refresh', i: 'refresh', c: '#10B981', fn: onRefresh }, { l: 'Employees', i: 'account-group', c: '#0e4e96', fn: handleViewEmployees }, { l: 'Internships', i: 'school', c: '#B45309', fn: handleViewInternships }, { l: 'Evaluation', i: 'clipboard-check', c: '#7C3AED', fn: () => navigation?.navigate('EvaluationAssessmentScreen', { companyLogo, companyName }) },
        { l: 'Clear Data', i: 'delete-sweep', c: '#EF4444', fn: () => Alert.alert('Clear', 'Clear mentor data?', [{ text: 'Cancel' }, { text: 'Clear', onPress: async () => { await AsyncStorage.removeItem('mentorData'); } }]) },
      ].map((item, i) => (<TouchableOpacity key={i} style={{ flexDirection: 'row', alignItems: 'center', paddingVertical: 14, borderBottomWidth: i < 4 ? 1 : 0, borderBottomColor: '#F3F4F6' }} onPress={item.fn}>
        <MaterialCommunityIcons name={item.i} size={22} color={item.c} style={{ marginRight: 12 }} /><Text style={{ flex: 1, fontSize: 15, fontWeight: '500', color: '#1F2937' }}>{item.l}</Text><MaterialCommunityIcons name="chevron-right" size={20} color="#9CA3AF" /></TouchableOpacity>))}</View>
  </ScrollView>);

  const renderContent = () => {
    switch (activeTab) {
      case 'overview':
        return renderOverview();
      case 'mentees':
        return renderMentees();
      case 'meetings':
        return renderMeetings();
      case 'resources':
        return renderResources();
      case 'progress':
        return renderProgressTab();
      case 'evaluate':
        return renderEvaluateTab();
      case 'reports':
        return renderReportsTab();
      case 'settings':
        return renderSettingsTab();
      default:
        return renderOverview();
    }
  };

  return (
    <SafeAreaView style={styles.container}>
      {renderHeader()}
      {renderTabBar()}
      {renderContent()}
      
      <Modal
        visible={showModal}
        animationType="slide"
        presentationStyle="pageSheet"
      >
        {renderModal()}
      </Modal>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#667eea',
  },
  header: {
    paddingBottom: 20,
  },
  headerContent: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 20,
    paddingTop: 10,
  },
  backButton: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  headerTitleContainer: {
    flex: 1,
    alignItems: 'center',
  },
  headerTitle: {
    fontSize: 20,
    fontWeight: '700',
    color: '#FFFFFF',
  },
  headerSubtitle: {
    fontSize: 14,
    color: 'rgba(255, 255, 255, 0.8)',
    marginTop: 2,
  },
  notificationButton: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
  },
  notificationBadge: {
    position: 'absolute',
    top: -2,
    right: -2,
    backgroundColor: '#EF4444',
    borderRadius: 10,
    minWidth: 20,
    height: 20,
    justifyContent: 'center',
    alignItems: 'center',
  },
  notificationBadgeText: {
    fontSize: 12,
    fontWeight: '600',
    color: '#FFFFFF',
  },
  tabBar: {
    flexDirection: 'row',
    backgroundColor: '#FFFFFF',
    borderBottomWidth: 1,
    borderBottomColor: '#E5E5EA',
  },
  tabItem: {
    flex: 1,
    paddingVertical: 12,
    alignItems: 'center',
    justifyContent: 'center',
  },
  activeTab: {
    borderBottomWidth: 2,
    borderBottomColor: '#667eea',
  },
  tabText: {
    fontSize: 12,
    fontWeight: '500',
    color: '#8E8E93',
    marginTop: 4,
  },
  activeTabText: {
    color: '#667eea',
  },
  content: {
    flex: 1,
    backgroundColor: '#F8F9FA',
  },
  profileCard: {
    backgroundColor: '#FFFFFF',
    marginHorizontal: 20,
    marginTop: 20,
    marginBottom: 16,
    borderRadius: 16,
    padding: 20,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 2,
  },
  profileHeader: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  profileAvatar: {
    width: 80,
    height: 80,
    borderRadius: 40,
    marginRight: 16,
  },
  profileInfo: {
    flex: 1,
  },
  profileName: {
    fontSize: 20,
    fontWeight: '700',
    color: '#1C1C1E',
    marginBottom: 4,
  },
  profileTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: '#667eea',
    marginBottom: 2,
  },
  profileDepartment: {
    fontSize: 14,
    color: '#8E8E93',
    marginBottom: 8,
  },
  ratingContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
  },
  ratingText: {
    fontSize: 16,
    fontWeight: '600',
    color: '#1C1C1E',
  },
  ratingCount: {
    fontSize: 14,
    color: '#8E8E93',
  },
  editButton: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: '#F8F9FA',
    justifyContent: 'center',
    alignItems: 'center',
  },
  statsGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    paddingHorizontal: 20,
    gap: 12,
    marginBottom: 16,
  },
  statCard: {
    width: Dimensions.get('window').width / 2 - 32,
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    padding: 20,
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 2,
  },
  statNumber: {
    fontSize: 24,
    fontWeight: '700',
    color: '#1C1C1E',
    marginTop: 8,
    marginBottom: 4,
  },
  statLabel: {
    fontSize: 14,
    color: '#8E8E93',
    textAlign: 'center',
  },
  sectionCard: {
    backgroundColor: '#FFFFFF',
    marginHorizontal: 20,
    marginBottom: 16,
    borderRadius: 16,
    padding: 20,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 2,
  },
  sectionHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 16,
  },
  sectionTitle: {
    fontSize: 18,
    fontWeight: '700',
    color: '#1C1C1E',
  },
  sectionAction: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
  },
  sectionActionText: {
    fontSize: 14,
    fontWeight: '600',
    color: '#667eea',
  },
  menteePreviewCard: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 12,
    borderBottomWidth: 1,
    borderBottomColor: '#F0F0F5',
  },
  menteeAvatar: {
    width: 48,
    height: 48,
    borderRadius: 24,
    marginRight: 12,
  },
  menteeInfo: {
    flex: 1,
  },
  menteeName: {
    fontSize: 16,
    fontWeight: '600',
    color: '#1C1C1E',
    marginBottom: 2,
  },
  menteeProgram: {
    fontSize: 14,
    color: '#8E8E93',
    marginBottom: 4,
  },
  progressContainer: {
    marginBottom: 4,
  },
  progressLabel: {
    fontSize: 12,
    fontWeight: '500',
    color: '#8E8E93',
    marginBottom: 4,
  },
  progressBar: {
    height: 6,
    backgroundColor: '#E5E5EA',
    borderRadius: 3,
    overflow: 'hidden',
  },
  progressFill: {
    height: '100%',
    backgroundColor: '#667eea',
  },
  progressText: {
    fontSize: 12,
    color: '#8E8E93',
    textAlign: 'right',
    marginTop: 2,
  },
  statusBadge: {
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 12,
  },
  statusText: {
    fontSize: 12,
    fontWeight: '600',
  },
  meetingPreviewCard: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 12,
    borderBottomWidth: 1,
    borderBottomColor: '#F0F0F5',
  },
  meetingIcon: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: '#F0F0F5',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 12,
  },
  meetingInfo: {
    flex: 1,
  },
  meetingTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: '#1C1C1E',
    marginBottom: 2,
  },
  meetingMentee: {
    fontSize: 14,
    color: '#8E8E93',
    marginBottom: 2,
  },
  meetingTime: {
    fontSize: 14,
    color: '#667eea',
    fontWeight: '500',
  },
  joinButton: {
    backgroundColor: '#667eea',
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderRadius: 8,
  },
  joinButtonText: {
    fontSize: 14,
    fontWeight: '600',
    color: '#FFFFFF',
  },
  quickActionsGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 12,
    marginTop: 16,
  },
  quickActionCard: {
    width: Dimensions.get('window').width / 2 - 32,
    backgroundColor: '#F8F9FA',
    borderRadius: 12,
    padding: 20,
    alignItems: 'center',
    borderWidth: 1,
    borderColor: '#E5E5EA',
  },
  quickActionText: {
    fontSize: 14,
    fontWeight: '600',
    color: '#1C1C1E',
    marginTop: 8,
    textAlign: 'center',
  },
  searchContainer: {
    paddingHorizontal: 20,
    paddingVertical: 16,
  },
  searchInputContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#FFFFFF',
    borderRadius: 12,
    paddingHorizontal: 16,
    paddingVertical: 12,
    gap: 8,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 2,
    elevation: 1,
  },
  searchInput: {
    flex: 1,
    fontSize: 16,
    color: '#1C1C1E',
  },
  menteeCard: {
    backgroundColor: '#FFFFFF',
    marginHorizontal: 20,
    marginBottom: 16,
    borderRadius: 16,
    padding: 20,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 2,
  },
  menteeCardHeader: {
    flexDirection: 'row',
    marginBottom: 16,
  },
  menteeCardAvatar: {
    width: 60,
    height: 60,
    borderRadius: 30,
    marginRight: 16,
  },
  menteeCardInfo: {
    flex: 1,
  },
  menteeCardName: {
    fontSize: 18,
    fontWeight: '700',
    color: '#1C1C1E',
    marginBottom: 4,
  },
  menteeCardProgram: {
    fontSize: 16,
    fontWeight: '600',
    color: '#667eea',
    marginBottom: 4,
  },
  menteeCardUniversity: {
    fontSize: 14,
    color: '#8E8E93',
    marginBottom: 4,
  },
  menteeCardMeta: {
    marginTop: 4,
  },
  menteeCardDates: {
    fontSize: 13,
    color: '#8E8E93',
  },
  skillsContainer: {
    marginBottom: 16,
  },
  skillsLabel: {
    fontSize: 14,
    fontWeight: '600',
    color: '#1C1C1E',
    marginBottom: 8,
  },
  skillsRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
  },
  skillChip: {
    paddingHorizontal: 12,
    paddingVertical: 6,
    backgroundColor: '#F0F0F5',
    borderRadius: 16,
  },
  skillChipText: {
    fontSize: 13,
    fontWeight: '500',
    color: '#667eea',
  },
  moreSkills: {
    fontSize: 13,
    color: '#8E8E93',
    alignSelf: 'center',
  },
  menteeCardFooter: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  performanceIndicator: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
  },
  performanceText: {
    fontSize: 14,
    fontWeight: '600',
    color: '#1C1C1E',
  },
  lastMeetingText: {
    fontSize: 13,
    color: '#8E8E93',
  },
  meetingsHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 20,
    paddingVertical: 16,
  },
  meetingsTitle: {
    fontSize: 24,
    fontWeight: '700',
    color: '#1C1C1E',
  },
  addMeetingButton: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    backgroundColor: '#667eea',
    paddingHorizontal: 16,
    paddingVertical: 10,
    borderRadius: 12,
  },
  addMeetingButtonText: {
    fontSize: 16,
    fontWeight: '600',
    color: '#FFFFFF',
  },
  meetingCard: {
    backgroundColor: '#FFFFFF',
    marginHorizontal: 20,
    marginBottom: 16,
    borderRadius: 16,
    padding: 20,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 2,
  },
  meetingCardHeader: {
    flexDirection: 'row',
    marginBottom: 12,
  },
  meetingTypeIcon: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: '#F0F0F5',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 12,
  },
  meetingCardInfo: {
    flex: 1,
  },
  meetingCardTitle: {
    fontSize: 18,
    fontWeight: '700',
    color: '#1C1C1E',
    marginBottom: 4,
  },
  meetingCardMentee: {
    fontSize: 16,
    fontWeight: '600',
    color: '#667eea',
    marginBottom: 4,
  },
  meetingCardDateTime: {
    fontSize: 14,
    color: '#8E8E93',
    marginBottom: 2,
  },
  meetingCardPlatform: {
    fontSize: 13,
    color: '#8E8E93',
  },
  agendaPreview: {
    marginBottom: 16,
    padding: 12,
    backgroundColor: '#F8F9FA',
    borderRadius: 12,
  },
  agendaLabel: {
    fontSize: 14,
    fontWeight: '600',
    color: '#1C1C1E',
    marginBottom: 4,
  },
  agendaText: {
    fontSize: 14,
    color: '#3C3C43',
    lineHeight: 20,
  },
  meetingActions: {
    flexDirection: 'row',
    gap: 12,
  },
  joinMeetingButton: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    backgroundColor: '#667eea',
    paddingVertical: 12,
    borderRadius: 12,
  },
  joinMeetingButtonText: {
    fontSize: 16,
    fontWeight: '600',
    color: '#FFFFFF',
  },
  editMeetingButton: {
    width: 48,
    height: 48,
    borderRadius: 12,
    backgroundColor: '#F8F9FA',
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: '#E5E5EA',
  },
  resourcesHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 20,
    paddingVertical: 16,
  },
  resourcesTitle: {
    fontSize: 24,
    fontWeight: '700',
    color: '#1C1C1E',
  },
  addResourceButton: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    backgroundColor: '#10B981',
    paddingHorizontal: 16,
    paddingVertical: 10,
    borderRadius: 12,
  },
  addResourceButtonText: {
    fontSize: 16,
    fontWeight: '600',
    color: '#FFFFFF',
  },
  resourceCard: {
    backgroundColor: '#FFFFFF',
    marginHorizontal: 20,
    marginBottom: 16,
    borderRadius: 16,
    padding: 20,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 2,
  },
  resourceHeader: {
    flexDirection: 'row',
    marginBottom: 12,
  },
  resourceTypeIcon: {
    width: 48,
    height: 48,
    borderRadius: 24,
    backgroundColor: '#F0F0F5',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 16,
  },
  resourceInfo: {
    flex: 1,
  },
  resourceTitle: {
    fontSize: 18,
    fontWeight: '700',
    color: '#1C1C1E',
    marginBottom: 4,
  },
  resourceCategory: {
    fontSize: 14,
    color: '#8E8E93',
    marginBottom: 8,
  },
  resourceDescription: {
    fontSize: 15,
    color: '#3C3C43',
    lineHeight: 22,
  },
  resourceTags: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
    marginBottom: 16,
  },
  resourceTag: {
    paddingHorizontal: 8,
    paddingVertical: 4,
    backgroundColor: '#E8F5E8',
    borderRadius: 12,
  },
  resourceTagText: {
    fontSize: 12,
    fontWeight: '500',
    color: '#10B981',
  },
  moreTags: {
    fontSize: 12,
    color: '#8E8E93',
    alignSelf: 'center',
  },
  resourceFooter: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  sharedWithText: {
    fontSize: 13,
    color: '#8E8E93',
  },
  resourceActions: {
    flexDirection: 'row',
    gap: 12,
  },
  shareButton: {
    width: 32,
    height: 32,
    borderRadius: 16,
    backgroundColor: '#F8F9FA',
    justifyContent: 'center',
    alignItems: 'center',
  },
  openButton: {
    width: 32,
    height: 32,
    borderRadius: 16,
    backgroundColor: '#F8F9FA',
    justifyContent: 'center',
    alignItems: 'center',
  },
  emptyState: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: 60,
  },
  emptyStateTitle: {
    fontSize: 20,
    fontWeight: '700',
    color: '#1C1C1E',
    marginTop: 16,
    marginBottom: 8,
  },
  emptyStateText: {
    fontSize: 16,
    color: '#8E8E93',
    textAlign: 'center',
    marginBottom: 24,
  },
  emptyStateButton: {
    backgroundColor: '#667eea',
    paddingHorizontal: 24,
    paddingVertical: 12,
    borderRadius: 12,
  },
  emptyStateButtonText: {
    fontSize: 16,
    fontWeight: '600',
    color: '#FFFFFF',
  },
  modalContent: {
    flex: 1,
    backgroundColor: '#F8F9FA',
  },
  modalHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 20,
    paddingVertical: 16,
    backgroundColor: '#FFFFFF',
    borderBottomWidth: 1,
    borderBottomColor: '#E5E5EA',
  },
  modalCloseButton: {
    width: 32,
    height: 32,
    borderRadius: 16,
    backgroundColor: '#F0F0F5',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalTitle: {
    fontSize: 18,
    fontWeight: '700',
    color: '#1C1C1E',
  },
  modalActionButton: {
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderRadius: 8,
  },
  modalActionText: {
    fontSize: 16,
    fontWeight: '600',
    color: '#667eea',
  },
  modalBody: {
    flex: 1,
    padding: 20,
  },
  detailsContainer: {
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    padding: 20,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 2,
  },
  menteeDetailsHeader: {
    flexDirection: 'row',
    marginBottom: 24,
  },
  menteeDetailsAvatar: {
    width: 80,
    height: 80,
    borderRadius: 40,
    marginRight: 16,
  },
  menteeDetailsInfo: {
    flex: 1,
  },
  menteeDetailsName: {
    fontSize: 20,
    fontWeight: '700',
    color: '#1C1C1E',
    marginBottom: 4,
  },
  menteeDetailsProgram: {
    fontSize: 16,
    fontWeight: '600',
    color: '#667eea',
    marginBottom: 4,
  },
  menteeDetailsUniversity: {
    fontSize: 14,
    color: '#8E8E93',
    marginBottom: 8,
  },
  contactInfo: {
    marginTop: 4,
  },
  contactText: {
    fontSize: 14,
    color: '#3C3C43',
  },
  detailsSection: {
    marginBottom: 24,
  },
  detailsSectionTitle: {
    fontSize: 18,
    fontWeight: '700',
    color: '#1C1C1E',
    marginBottom: 12,
  },
  progressDates: {
    fontSize: 14,
    color: '#8E8E93',
    marginTop: 8,
  },
  performanceGrid: {
    gap: 16,
  },
  performanceItem: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: 8,
  },
  performanceCategory: {
    fontSize: 16,
    color: '#1C1C1E',
    flex: 1,
  },
  ratingStars: {
    flexDirection: 'row',
    gap: 2,
    marginHorizontal: 12,
  },
  ratingValue: {
    fontSize: 16,
    fontWeight: '600',
    color: '#1C1C1E',
    minWidth: 32,
    textAlign: 'right',
  },
  goalItem: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 12,
    marginBottom: 8,
  },
  goalText: {
    flex: 1,
    fontSize: 15,
    color: '#3C3C43',
    lineHeight: 22,
  },
  achievementItem: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 12,
    marginBottom: 8,
  },
  achievementText: {
    flex: 1,
    fontSize: 15,
    color: '#3C3C43',
    lineHeight: 22,
  },
  skillsGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
  },
  detailsDescription: {
    fontSize: 15,
    color: '#3C3C43',
    lineHeight: 22,
  },
  formGroup: {
    marginBottom: 20,
  },
  formLabel: {
    fontSize: 16,
    fontWeight: '600',
    color: '#1C1C1E',
    marginBottom: 8,
  },
  formInput: {
    backgroundColor: '#FFFFFF',
    borderRadius: 12,
    paddingHorizontal: 16,
    paddingVertical: 12,
    fontSize: 16,
    color: '#1C1C1E',
    borderWidth: 1,
    borderColor: '#E5E5EA',
  },
  formSelect: {
    backgroundColor: '#FFFFFF',
    borderRadius: 12,
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderWidth: 1,
    borderColor: '#E5E5EA',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  formSelectText: {
    fontSize: 16,
    color: '#1C1C1E',
  },
  formRow: {
    flexDirection: 'row',
    gap: 12,
  },
  formGroupHalf: {
    flex: 1,
    marginBottom: 20,
  },
  textArea: {
    height: 100,
    textAlignVertical: 'top',
  },
  notificationItem: {
    flexDirection: 'row',
    padding: 16,
    backgroundColor: '#FFFFFF',
    borderRadius: 12,
    marginBottom: 12,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 2,
    elevation: 1,
  },
  unreadNotification: {
    backgroundColor: '#F0F0F5',
  },
  notificationIcon: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: '#F0F0F5',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 12,
  },
  notificationContent: {
    flex: 1,
  },
  notificationTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: '#1C1C1E',
    marginBottom: 4,
  },
  notificationMessage: {
    fontSize: 14,
    color: '#3C3C43',
    marginBottom: 4,
    lineHeight: 20,
  },
  notificationDate: {
    fontSize: 13,
    color: '#8E8E93',
  },
  unreadDot: {
    width: 8,
    height: 8,
    borderRadius: 4,
    backgroundColor: '#667eea',
    marginLeft: 8,
    alignSelf: 'center',
  },
});

// Additional styles for new modals
const additionalStyles = {
  meetingTitle: {
    fontSize: 20,
    fontWeight: '700',
    color: '#1C1C1E',
    marginBottom: 16,
  },
  meetingInfoRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 12,
    paddingHorizontal: 4,
  },
  meetingInfoText: {
    fontSize: 16,
    color: '#3C3C43',
    marginLeft: 12,
    flex: 1,
  },
  meetingSection: {
    marginTop: 20,
    paddingTop: 16,
    borderTopWidth: 1,
    borderTopColor: '#E5E5EA',
  },
  meetingSectionTitle: {
    fontSize: 18,
    fontWeight: '600',
    color: '#1C1C1E',
    marginBottom: 12,
  },
  meetingAgendaItem: {
    fontSize: 16,
    color: '#3C3C43',
    marginBottom: 8,
    paddingLeft: 8,
  },
  meetingSummary: {
    fontSize: 16,
    color: '#3C3C43',
    lineHeight: 24,
  },
  meetingActionItem: {
    fontSize: 16,
    color: '#3C3C43',
    marginBottom: 8,
    paddingLeft: 8,
  },
};

// Additional styles for new modals
const newModalStyles = {
  formGroup: {
    marginBottom: 20,
  },
  formLabel: {
    fontSize: 16,
    fontWeight: '600',
    color: '#1C1C1E',
    marginBottom: 8,
  },
  formInput: {
    borderWidth: 1,
    borderColor: '#E5E5EA',
    borderRadius: 12,
    paddingHorizontal: 16,
    paddingVertical: 12,
    fontSize: 16,
    color: '#1C1C1E',
    backgroundColor: '#FFFFFF',
  },
  textArea: {
    height: 100,
    textAlignVertical: 'top',
  },
  resourceTypeContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
  },
  resourceTypeButton: {
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderRadius: 20,
    backgroundColor: '#F2F2F7',
    borderWidth: 1,
    borderColor: '#E5E5EA',
  },
  resourceTypeText: {
    fontSize: 14,
    color: '#3C3C43',
  },
  submitButton: {
    backgroundColor: '#667eea',
    borderRadius: 12,
    paddingVertical: 16,
    alignItems: 'center',
    marginTop: 20,
  },
  submitButtonText: {
    fontSize: 16,
    fontWeight: '600',
    color: '#FFFFFF',
  },
  feedbackMentee: {
    fontSize: 18,
    fontWeight: '600',
    color: '#1C1C1E',
    marginBottom: 20,
  },
  ratingSection: {
    marginBottom: 20,
  },
  ratingLabel: {
    fontSize: 16,
    fontWeight: '600',
    color: '#1C1C1E',
    marginBottom: 8,
  },
  ratingStars: {
    flexDirection: 'row',
    gap: 4,
  },
  analyticsCard: {
    backgroundColor: '#F8F9FA',
    borderRadius: 12,
    padding: 16,
    marginBottom: 16,
  },
  analyticsTitle: {
    fontSize: 18,
    fontWeight: '600',
    color: '#1C1C1E',
    marginBottom: 12,
  },
  analyticsRow: {
    flexDirection: 'row',
    justifyContent: 'space-around',
  },
  analyticsItem: {
    alignItems: 'center',
  },
  analyticsNumber: {
    fontSize: 24,
    fontWeight: '700',
    color: '#667eea',
  },
  analyticsLabel: {
    fontSize: 14,
    color: '#8E8E93',
    marginTop: 4,
  },
  metricRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingVertical: 8,
    borderBottomWidth: 1,
    borderBottomColor: '#E5E5EA',
  },
  metricLabel: {
    fontSize: 16,
    color: '#3C3C43',
  },
  metricValue: {
    fontSize: 16,
    fontWeight: '600',
    color: '#667eea',
  },
  resourcePreview: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 16,
    backgroundColor: '#F8F9FA',
    borderRadius: 12,
    marginBottom: 20,
  },
  resourcePreviewInfo: {
    flex: 1,
    marginLeft: 12,
  },
  resourcePreviewTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: '#1C1C1E',
    marginBottom: 4,
  },
  resourcePreviewCategory: {
    fontSize: 14,
    color: '#8E8E93',
  },
  shareSection: {
    marginBottom: 20,
  },
  shareSectionTitle: {
    fontSize: 18,
    fontWeight: '600',
    color: '#1C1C1E',
    marginBottom: 16,
  },
  menteeShareItem: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 12,
    paddingHorizontal: 16,
    borderRadius: 12,
    marginBottom: 8,
    backgroundColor: '#FFFFFF',
    borderWidth: 1,
    borderColor: '#E5E5EA',
  },
  menteeShareItemSelected: {
    backgroundColor: '#F0F9FF',
    borderColor: '#667eea',
  },
  menteeShareAvatar: {
    width: 40,
    height: 40,
    borderRadius: 20,
    marginRight: 12,
  },
  menteeShareInfo: {
    flex: 1,
  },
  menteeShareName: {
    fontSize: 16,
    fontWeight: '600',
    color: '#1C1C1E',
    marginBottom: 2,
  },
  menteeShareProgram: {
    fontSize: 14,
    color: '#8E8E93',
  },
  menteeShareStatus: {
    marginLeft: 8,
  },
  shareOptions: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    paddingTop: 20,
    borderTopWidth: 1,
    borderTopColor: '#E5E5EA',
  },
  shareOptionButton: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 12,
    paddingHorizontal: 20,
    borderRadius: 12,
    backgroundColor: '#F8F9FA',
  },
  shareOptionText: {
    fontSize: 16,
    fontWeight: '500',
    color: '#667eea',
    marginLeft: 8,
  },
};

// Merge additional styles with existing styles
Object.assign(styles, additionalStyles, newModalStyles);

export default MentorDashboardScreen;